import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateQr } from "../utils/functions";
import { Modal } from "react-bootstrap";
import { generateAuthorizationCode } from "../features/authorizationSlice";

const PortalActionsQr = ({ isOpen, onClose }) => {
    const [qrCode, setQrCode] = useState("");
    const {qrData, loading, qrTimeout, validationInfo, additionalData} = useSelector((state) => state.authorization);

    useEffect(() => {
        if (qrData && qrData.length > 0) {
            generateQr(qrData).then(res => setQrCode(res));
        } else {
            setQrCode("");
        }
    }, [qrData]);

    const dispatch = useDispatch();


    return (
        <Modal centered show={isOpen} onHide={onClose}>
            <Modal.Body>
                <div className="header">
                    <div className="modal-header-image">
                        <img src="Images/caution.png"/>
                    </div>

                    {
                        validationInfo ? (
                            <div className="validation-info">
                                <span>{validationInfo?.title}</span>
                                {
                                    (validationInfo?.profile ) &&
                                    <div className="listing profile">
                                        <img src={'/Images/'+validationInfo.profile?.icon} alt=""/>
                                        <div className="desc">
                                            <div className="label">{validationInfo.profile?.label}</div>
                                            <div className="name">{validationInfo.profile?.name}</div>
                                        </div>
                                    </div>
                                }
                                {
                                     validationInfo.listings?.map(({label, value}, index) => (
                                        <div className="listing" key={index}>
                                            <div className="label">{label}</div>
                                            <div className="value">{value}</div>
                                        </div>
                                    ))
                                }
                                {
                                    validationInfo?.document?.documentName &&
                                    <div className="listing document">
                                        <div className="label">Document</div>
                                        <div className="value">
                                            {/*<a href={validationInfo.document?.documentUrl} target="_blank">{validationInfo.document?.documentName}</a>*/}
                                            <a href="#">{validationInfo.document?.documentName}</a>
                                        </div>
                                    </div>
                                }
                            </div>
                        ) : (
                            <span>Access Needed</span>
                        )
                    }
                </div>
                <div>
                    {
                        loading === "pending" ? (
                            <div className="qr-loading">
                                <img src='/Images/skash_Rocket.gif' alt='Loading...'/>
                            </div>
                        )  : (
                            <div>
                                <div className="qr-cont" style={{'backgroundImage': `url(${qrCode})`}}>
                                    {qrTimeout && (
                                        <div
                                            className='red-circle'
                                            onClick={() => {
                                                dispatch(generateAuthorizationCode(additionalData));
                                            }}>
                                            <div className="qr-reload">
                                                <img src='/Images/skash_loading.png' alt='loading' className="loading-img"/>
                                                <p className="reload-text">CLICK TO RELOAD QR CODE</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <p className="scan-text">
                                    Scan to Validate.
                                </p>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

export default PortalActionsQr;
